import { createContext } from "react";
var MenuContext = createContext({});
export default MenuContext;